import { browserName } from 'react-device-detect';
import { getApiOrigin } from '../config/apiOrigin';

const apiHost = getApiOrigin();

type ClickedOn =
  | 'login.button'
  | 'forgot.password.button'
  | 'reset.password.button'
  | 'signup.button'
  | 'create.match.game.button'
  | 'create.sit-n-go.game.button'
  | 'create.solo.game.button'
  | 'create.pool.game.button'
  | 'create.bracket.game.button'
  | 'rejoin.game.button'
  | 'spectate.game.button'
  | 'header.logo.link'
  | 'header.inaccuracies.report.link'
  | 'header.profile.link'
  | 'header.logout.link'
  | 'header.admin.link'
  | 'profile.games.table.row'
  | 'profile.games.table.username.link'
  | 'lobby.username.link'
  | 'leaderboard.wins.username.link'
  | 'leaderboard.solos.username.link'
  | 'scorecard.share.button'
  | 'rankings.username.link';

export const track = async (
  profileId: string | null,
  clickedOn: ClickedOn,
  target?: string
) => {
  const urlWithApiHost = apiHost + '/track';
  const body = {
    browser: browserName,
    profileId,
    clickedOn,
    target,
  };
  try {
    const response = await fetch(urlWithApiHost, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (response.status !== 200) throw response;
    return response.json();
  } catch (e) {
    console.log('CATCH', e);
  }
};
